import { combineReducers, configureStore } from '@reduxjs/toolkit';
import { TypedUseSelectorHook, useDispatch, useSelector } from 'react-redux';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';

import reducers from 'Reducer';
import api from 'Service';
import { apiViaCep } from 'View/Service/viacep';

const persistedReducer = persistReducer(
  {
    key: 'root',
    storage,
  },
  combineReducers(reducers)
);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (middlewares) =>
    middlewares({ serializableCheck: false }).concat(
      api.middleware,
      apiViaCep.middleware
    ),
});

const persistor = persistStore(store);

export type Estado = ReturnType<typeof store.getState>;
export type Dispatch = typeof store.dispatch;

export const useAppDispatch = () => useDispatch<Dispatch>();
export const useAppSelector: TypedUseSelectorHook<Estado> = useSelector;

export { store, persistor };
